import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import MODAL_TYPES from 'constants/modals';
import { getActiveVolume } from 'store/selectors/learningCommunity';
import { useRemoveLearningCommunityVolumeMutation } from 'store/services/learningCommunities/volumeChapter';
import { showModal } from 'store/slices/modal';
import Button from 'style-guide/Button';
import { Down, Top, Trash } from 'style-guide/Icons';
import Title from 'style-guide/Typography/Title';
import VolumeDragHandle from './VolumeDragHandle';

const VolumeBox = ({ isOpen, isLast, setOpenKeys, volumeId, name, isPreview }) => {
  const dispatch = useDispatch();
  const [removeVolume] = useRemoveLearningCommunityVolumeMutation();
  const activeVolumeData = useSelector(getActiveVolume);

  const { id, role } = useParams();

  const isMember = role === 'member';

  const isActiveVolume = volumeId === activeVolumeData?.id;

  const onRemove = () => {
    dispatch(
      showModal({
        type: MODAL_TYPES.CONFIRMATION,
        params: {
          modal: {
            title: 'Confirmation',
          },
          body: {
            title: <Title variant={5}>Are you sure you want to delete?</Title>,
            onOk: () => removeVolume({ volumeId, id }),
          },
        },
      })
    );
  };

  return (
    <div className='pv--8 ph--16 d-flex align-items-center justify-content-between volume-box'>
      <VolumeDragHandle
        name={name}
        volumeId={volumeId}
        id={id}
        setOpenKeys={setOpenKeys}
        isOpen={isOpen}
        isPreview={isPreview}
      />
      <div className='d-flex align-items-center buttons-section' data-testid='dropdown-icon'>
        {!isLast && !isActiveVolume && !isMember ? (
          <Button className='trash-icon pv--0' onClick={onRemove}>
            <Trash width={12} height={12} />
          </Button>
        ) : null}
        <Button
          className='p--0'
          onClick={() => setOpenKeys((items) => (isOpen ? items.filter((e) => e !== volumeId) : [...items, volumeId]))}
        >
          {isOpen ? <Top width={12} height={12} /> : <Down width={12} height={12} />}
        </Button>
      </div>
    </div>
  );
};

export default VolumeBox;
